import {
    FieldsActionTypes,
    AddFieldWithTempIdActionType,
    DeleteFieldRequestActionType,
    DuplicateFieldRequestActionType,
    DuplicateFieldWithTempIdActionType,
    InitFieldsActionType,
    AddFieldRequestActionType,
    AddFieldSuccessActionType,
    AddFieldFailureActionType,
    UpdateFieldRequestActionType,
    UpdateFieldSuccessActionType,
    UpdateFieldFailureActionType,
    DuplicateFieldSuccessActionType,
    DuplicateFieldFailureActionType,
    DeleteFieldSuccessActionType,
    DeleteFieldFailureActionType,
    ChangeIsFomHavePromoCodeFieldActionType,
    ChangeIsFomHavePaymentTypeFieldActionType,
} from "./types";
import { ActionCreator } from "../types/store-types";

export const initFields: ActionCreator<InitFieldsActionType> = payload => ({
    type: FieldsActionTypes.INIT_FIELDS,
    payload,
});

/* -- Add Field Actions  -- */

export const addFieldWithTempId: ActionCreator<AddFieldWithTempIdActionType> = payload => ({
    type: FieldsActionTypes.ADD_WITH_TEMP_ID,
    payload,
});

export const addFieldRequest: ActionCreator<AddFieldRequestActionType> = payload => ({
    type: FieldsActionTypes.ADD_FIELD_REQUEST,
    payload,
});

export const addFieldSuccess: ActionCreator<AddFieldSuccessActionType> = payload => ({
    type: FieldsActionTypes.ADD_FIELD_SUCCESS,
    payload,
});

export const addFieldFailure: ActionCreator<AddFieldFailureActionType> = payload => ({
    type: FieldsActionTypes.ADD_FIELD_FAILURE,
    payload,
});

/* -- Update Field Actions  -- */

export const updateFieldRequest: ActionCreator<UpdateFieldRequestActionType> = payload => ({
    type: FieldsActionTypes.UPDATE_FIELD_REQUEST,
    payload,
});

export const updateFieldSuccess: ActionCreator<UpdateFieldSuccessActionType> = payload => ({
    type: FieldsActionTypes.UPDATE_FIELD_SUCCESS,
    payload,
});

export const updateFieldFailure: ActionCreator<UpdateFieldFailureActionType> = payload => ({
    type: FieldsActionTypes.UPDATE_FIELD_FAILURE,
    payload,
});

/* -- Delete Field Actions  -- */

export const deleteFieldRequest: ActionCreator<DeleteFieldRequestActionType> = payload => ({
    type: FieldsActionTypes.DELETE_FIELD_REQUEST,
    payload,
});

export const deleteFieldSuccess: ActionCreator<DeleteFieldSuccessActionType> = payload => ({
    type: FieldsActionTypes.DELETE_FIELD_SUCCESS,
    payload,
});

export const deleteFieldFailure: ActionCreator<DeleteFieldFailureActionType> = payload => ({
    type: FieldsActionTypes.DELETE_FIELD_FAILURE,
    payload,
});

/* -- Duplicate Field Actions -- */

export const duplicateFieldWithTempId: ActionCreator<DuplicateFieldWithTempIdActionType> = payload => ({
    type: FieldsActionTypes.DUPLICATE_FIELD_WITH_TEMP_ID,
    payload,
});

export const duplicateFieldRequest: ActionCreator<DuplicateFieldRequestActionType> = payload => ({
    type: FieldsActionTypes.DUPLICATE_FIELD_REQUEST,
    payload,
});

export const duplicateFieldSuccess: ActionCreator<DuplicateFieldSuccessActionType> = payload => ({
    type: FieldsActionTypes.DUPLICATE_FIELD_SUCCESS,
    payload,
});

export const duplicateFieldFailure: ActionCreator<DuplicateFieldFailureActionType> = payload => ({
    type: FieldsActionTypes.DUPLICATE_FIELD_FAILURE,
    payload,
});

export const changeIsFormHavePromoCodeField: ActionCreator<ChangeIsFomHavePromoCodeFieldActionType> = payload => ({
    type: FieldsActionTypes.CHANGE_IS_FORM_HAVE_PROMOCODE_FIELD,
    payload,
});

export const changeIsFormHavePaymentTypeField: ActionCreator<ChangeIsFomHavePaymentTypeFieldActionType> = payload => ({
    type: FieldsActionTypes.CHANGE_IS_FORM_HAVE_PAYMENT_TYPE_FIELD,
    payload,
});
